/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import cancelIcon from '../../../../assets/images/Icon-cancel.png';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import { chooseContactTableHead } from './gridComponents/tableHead';
import {
  getInvChooseContactData,
  getDisputeChooseContactData,
} from '../store/actions';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { PaperComponent } from '../../../../SharedModules/utilities/utilities';

export default function SelectContractModal(props) {
  const {
    setSelectedContact,
    open,
    setContactIfNotEmpty,
    handleClose,
    invoiceContact,
    disputeContract,
  } = props;
  const dispatch = useDispatch();
  const searchContractState = useSelector(
    (state) => state.sharedState?.ContractReducer?.searchContractState
  );
  const getAllContractData = useSelector(
    (state) => state.sharedState?.ContractReducer?.getAllContractData
  );
  const maintainContractState = useSelector(
    (state) => state.sharedState.ContractReducer?.maintainContractState
  );
  const invoiceContactList = useSelector(
    (state) => state.sharedState.ContractReducer?.selectInvoiceContactList
  );
  const disputeContactList = useSelector(
    (state) => state.sharedState.ContractReducer?.selectDisputeContactList
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const gridRef = React.useRef();
  const [showAll, setShowAll] = React.useState(false);
  const [selectContact, setSelectContact] = React.useState(null);
  const [errorMessages, setErrorMessages] = React.useState([]);
  const [gridApi, setGridApi] = React.useState(null);

  const fetchInvoiceContactList = (val) => {
    // handleClearFilter()
    if (searchContractState.contractType === 'onSelect') {
      let temp = {
        mfgId:
          getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab?.mfgId,
        contactTypeCd: 'INV',
      };
      if (val) temp = { ...temp, contactTypeCd: '' };
      dispatch(getInvChooseContactData(temp));
    } else {
      const temp = {
        mfgId: searchContractState?.selectedRowData,
        contactTypeCd: 'INV',
      };
      dispatch(getInvChooseContactData(temp));
    }
  };

  const fetchDisputeContactList = (val) => {
    // handleClearFilter()
    if (searchContractState.contractType === 'onSelect') {
      const temp = {
        mfgId:
          getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab?.mfgId,
        contractId:
          getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
            ?.contractSeqNum,
        ccShowAll: val,
      };
      // if (!val) temp = { ...temp, contactTypeCd: 'CMSINV' }
      dispatch(getDisputeChooseContactData(temp));
    } else {
      let temp = {
        mfgId: searchContractState?.selectedRowData,
        contractId: maintainContractState.contractSeqNum,
        ccShowAll: val,
      };
      if (!val) temp = { ...temp, contactTypeCd: 'CMSINV' };
      dispatch(getInvChooseContactData(temp));
    }
  };

  React.useEffect(() => {
    if (
      invoiceContact &&
      (invoiceContactList === undefined || invoiceContactList?.length === 0)
    ) {
      fetchInvoiceContactList(false);
    }
    if (
      disputeContract &&
      (disputeContactList === undefined || disputeContactList?.length === 0)
    ) {
      fetchDisputeContactList(false);
    }
  }, []);
  // handing by default 1st row selection function
  const onGridReady = useCallback((params) => {
    params.api.forEachNode((node) =>
      node.rowIndex ? 1 : node.setSelected(true)
    );
    if (invoiceContact) {
      setSelectContact(
        invoiceContactList?.length > 0 ? invoiceContactList[0] : null
      );
    }
    if (disputeContract) {
      setSelectContact(
        disputeContactList?.length > 0 ? disputeContactList[0] : null
      );
    }
  });
  const onSelectionChanged = useCallback(
    (val) => {
      // const selectedRows = val.api.getSelectedRows();
      const selectRow = val.api?.getSelectedRows();
      setSelectContact(selectRow[0]);
    },
    [gridApi]
  );
  // click on filter icon after call

  const onSubmit = () => {
    if (selectContact === null) {
      setErrorMessages([constantMessageData.CONTRACT_NOT_SELECTED_ROW]);
    } else {
      setErrorMessages([]);
      setContactIfNotEmpty(selectContact);
      setSelectedContact(selectContact);
    }
  };
  // Ag-grid framework component
  const frameworkComponents = {
    renderCorporationName: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.corpName;
      if (name && name.length > 30) {
        return (
          <OverlayTrigger
            placement='bottom'
            overlay={<Tooltip id='labeler-tooltip'>{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    renderContractName: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.contactName;
      if (name && name.length > 30) {
        return (
          <OverlayTrigger
            placement='bottom'
            overlay={<Tooltip id='labeler-tooltip'>{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    renderCityName: (cellInfo) => {
      const name = cellInfo.data && cellInfo.data.city;
      if (name && name.length > 20) {
        return (
          <OverlayTrigger
            placement='bottom'
            overlay={<Tooltip id='labeler-tooltip'>{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
  };
  return (
    <>
      <Dialog
        open={open}
        data-testid='close-copy-contact-popup'
        maxWidth='md'
        className='inbuilt-dialog dialogPanel custom-check dialog-600'
        PaperComponent={PaperComponent}
        aria-labelledby='draggable-dialog-title'
      >
        <DialogTitle
          className='copy-contact-title'
          style={{ cursor: 'move' }}
          id='draggable-dialog-title'
        >
          <div className='float-left dialog-heading-txt mt-1'>
            Select Contact
          </div>

          <div
            className='close-popup-icon float-right'
            role='button'
            onClick={handleClose}
          >
            <img alt='' src={cancelIcon} />
          </div>
          <div className='clearfix' />
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div
              data-testid='copy-contact-popup'
              id='copy-contact-popup'
              className='common-popup'
            >
              {/* <Spinner load={spinnerLoader} /> */}
              <DisplayErrorMessages errorMessages={errorMessages} />
              <div className='panel tBillPanel-space devider-line pb-0'>
                <form autoComplete='off'>
                  <div className='form-wrapper'>
                    <div className='mui-custom-form input-md'>
                      <div className='sub-radio text-black sub-label'>
                        <FormControlLabel
                          control={
                            <Checkbox
                              value={showAll}
                              checked={showAll}
                              data-testid='checkbox'
                              onClick={() => {
                                setShowAll(!showAll);
                                setErrorMessages([]);
                                if (invoiceContact) {
                                  fetchInvoiceContactList(!showAll);
                                }
                                if (disputeContract) {
                                  fetchDisputeContactList(!showAll);
                                }
                              }}
                              color='primary'
                            />
                          }
                          label='Show All'
                          data-testid='showAll'
                        />
                      </div>
                    </div>
                  </div>
                </form>
                {(
                  <TableGridWithFeatures
                    ref={gridRef}
                    gridHeight={250}
                    onGridReady={onGridReady}
                    data-testid='contract-search-table'
                    rowData={
                      invoiceContact ? invoiceContactList : disputeContactList
                    }
                    columnDefs={chooseContactTableHead}
                    rowSelection='single'
                    navigateToNextCell={navigateToNextCell}
                    // tabToNextCell={tabToNextCell}
                    enterMovesDown
                    suppressCellFocus
                    childPopup
                    onCellFocused={onCellFocused}
                    // onSelect={(e) => {
                    //   const selectRow = e.api?.getSelectedRows();
                    //   setSelectContact(selectRow[0])
                    // }}
                    onSelectionChanged={onSelectionChanged}
                    applyFilter={false}
                    frameworkComponents={frameworkComponents}
                    fileName={
                      invoiceContact
                        ? 'Contract - Invoice Contact'
                        : 'Contract - Dispute Contact'
                    }
                    exportFile
                  />
                )}
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className='btn-wrapper mb-2'>
            <div className='float-right hide-on-print'>
              <Button
                className='btn btn-success btn-search'
                data-testid='reset-contact-detail'
                onClick={onSubmit}
              >
                <SVGComponent iconName='Icon_awesome-check-circle' />
                Ok
              </Button>
              <Button
                data-testid='copy-contact-close'
                className='btn btn-cancel btn-primary'
                onClick={handleClose}
              >
                <SVGComponent iconName='Icon-cancel' />
                Cancel
              </Button>
            </div>
            <div className='clearfix' />
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}
